import {useState, useEffect, useRef} from "react";
import { useParams } from 'react-router-dom';
import {
	Box,
	SimpleGrid,
	Image,
	useToast,
	GridItem,
	InputGroup,
	NumberInput,
	InputRightAddon,
	NumberInputField,
	Button,
} from "@chakra-ui/react";
import { format, getNFTStatus, shortAddress } from '../../utils/common';
import intl from "../../utils/intl";
import { getScore } from '../../utils/score';
import {
	CHAIN_ID,
	NFT_ADDRESS,
	BASE_API_URL,
	STAKING_TOKEN,
	PAYMENT_TOKEN,
	ETHER_SCAN_URL,
	MAX_TIMESTAMP,
	BASE_WEB_URL,
	SP_TOKEN_SYMBOL,
	SP_TOKEN_FACTORY,
	MARKETPLACE_ADDRESS,
	NFT_ONSALE_MIN_SCORE,
	STAKING_TOKEN_SYMBOL,
	PAYMENT_TOKEN_SYMBOL,
	ALLOCATION_ADDRESS,
	NUSIC_VAULT,
	SHARE_PROFIT_SPT_HOLDERS,
} from "../../config";
import ConfirmationProgress from '../ConfirmationProgress';
import { useAuth } from '../../contexts/AuthContext';
import { 
	getRate,
	toDataURL,
	getSPToken,
	toBigInt,
	getIPAccounts,
	toWei,
	fromWei,
	getNFTOwner,
	getTradeTimes,
	SPTokenContract,
	NFTCoreContract,
	getNusicPrice,
	getAllReleasable,
	getBlockTimestamp,
	getUnsupportFrozenTime,
	getStakingTokenBalance,
	MarketplaceContract,
	PaymentTokenContract,
	StakingTokenContract,
	SPTokenFactoryContract,
	AllocationData,
	getFirstSupportTimestamp,
	ipfsToHttp,
	ZERO
} from '../../utils/common';
import date from "date-and-time";
// import {ShareBar} from "../ItemList/ShareBar";

const ItemDetailBody = () => {
	let params = useParams();
	const [ nftData, setNftData ] = useState({});
	const [ status, setStatus ] = useState(0);
	const [ favours, setFavours ] = useState(0);
	const [ rate, setRate ] = useState(1000);
	const [ stakingTokenBalance, setStakingTokenBalance ] = useState(ZERO);
	const [ frozenTime, setFrozentime ] = useState(0);
	const [ firstSupportTime, setFirstSupportTime ] = useState(ZERO);
	const [ unsupportable, setUnsupportable ] = useState(false);
	const [ nusicPrice, setNusicPrice ] = useState("200000000000000000"); // 0.2U
	const [ NFTEstimatedPrice, setNFTEstimatedPrice ] = useState("0");
	const [ tradeTimes, setTradeTimes ] = useState(0);
	const [ allReleasable, setAllReleasable ] = useState("0");
	const [ IPAccounts, setIPAccounts ] = useState([]);

	const loadingImage = 'assets/img/loading.jpg';
	const toast = useToast();
  const { currentAccount } = useAuth();

	const [ hiddenConfirmationProgress, setHiddenConfirmationProgress ] = useState(true);
	const [ confirmationProgressData, setConfirmationProgressData ] = useState({value: 5, message: intl.get("start"), step: 1});

	const stakeAmount = useRef(0);
	const unstakeAmount = useRef(0);
	const listPrice = useRef(0);

	const sptokenFactoryContract = SPTokenFactoryContract();
	const stakingTokenContract = StakingTokenContract();
	const marketplaceContract = MarketplaceContract();
	const nftCoreContract = NFTCoreContract();
	const paymentTokenContract = PaymentTokenContract();
	const allocationDataContract = AllocationData();

	const darkBg = "#282828";
	const bg = "#333";
	const fontColor = "#ddd";
	const pink = "#815cd3";

	const parseFromTokenURI = async(nftData) => {
		const controller = new AbortController();
		if(nftData.tokenURI === undefined) return;
		const url = ipfsToHttp(nftData.tokenURI);
		// console.log(url);
		let res;
		try {
			res = await (await fetch(url, {
				method: 'GET',
				signal: controller.signal,
			})).json();	
		} catch (err) {
			console.log(err);
		}

		if(res !== undefined) {
			try {
				// Get staking and sptoken data from contract
				const sptoken = await getSPToken(currentAccount, nftData.tokenId);
				// console.log('balance', sptoken.sptMyBalance.toString());
				unstakeAmount.current = sptoken.sptMyBalance;
				const nftOwner = await getNFTOwner(nftData.tokenId);
				setStatus(await getNFTStatus(nftData, nftOwner, currentAccount));

				// console.log("nftData", {
				// 	...res,
				// 	...nftData,
				// 	...sptoken,
				// 	nftOwner,
				// });
				
				setNftData({
					...res,
					...nftData,
					...sptoken,
					nftOwner,
					imageBase64: res === undefined ? null : await toDataURL(ipfsToHttp(res.image))
				});

				listPrice.current = 0;//nftData.startingPrice === null ? 0 : nftData.startingPrice;
			} catch (err) {
				console.log("Error: getSPToken");
			}
		}			
	}

	useEffect(() => {
		if(currentAccount === undefined) return;
		const controller = new AbortController();
		const signal = controller.signal;
		let url = `${BASE_API_URL}/items/get_nft_by_id/${CHAIN_ID}/${NFT_ADDRESS}/${params.tokenId}`;
		// console.log(url);
		fetch(url, {
			method: "get",
			headers: { 'Content-Type': 'application/json' },
			signal,
		})
		.then((res) => res.json()
		.then(async (data) => {
			if(data.success) {
				// parseFromTokenURI: get data from tokenURI of IPFS and SPT data from chain
				const nftData = data.list[0];
				console.log("======", nftData);
				document.title = "Nusic NFT #" + nftData.tokenId;
				setFavours(nftData.favour);
				setRate(await getRate());
				setStakingTokenBalance(await getStakingTokenBalance(currentAccount));
				setFrozentime(await getUnsupportFrozenTime());
				setFirstSupportTime(await getFirstSupportTimestamp(nftData.tokenId));
				setTradeTimes(await getTradeTimes(nftData.tokenId));
				setAllReleasable(await getAllReleasable(nftData.tokenId, currentAccount));
				setIPAccounts(await getIPAccounts(nftData.tokenId));

				await parseFromTokenURI(nftData);
			} else {
				console.log("Loading data error for tokenId: ", params.tokenid);
			}
		}).catch((err) => {
			console.log(err);
		}));

		return() => controller.abort();
	},[currentAccount])

	const InfoLine = (props) => {
		return(
			<Box fontSize={14} mb={3} color={fontColor}>
				<Box ml={1}>{props.title}</Box>
				<Box borderRadius={6} bg={darkBg} p={2.5} mt={1} fontWeight={600}>{props.content}&nbsp;&nbsp;
					{props.url === undefined ? <></> :
					<a href={props.url} target="_blank" rel="noopener noreferrer">{props.linkText}</a>
					}
				</Box>
			</Box>
		)
	}

	const InfoBlock = (props) => {
		return(
			<Box fontSize={14} mb={3} color={fontColor}>
				<Box ml={1}>{props.title}</Box>
				<Box borderRadius={6} minHeight={props.height} bg={darkBg} p={2} mt={1} fontWeight={600}>{props.content}</Box>
			</Box>
		)
	}

	const StakeButtons = () => {
		return(
			<>
			{nftData.supportable === 1 ?  
			<Box borderRadius={6} borderColor={darkBg} borderWidth={1} pt={0} pl={5} pr={5} pb={5}>
				<Box fontSize={"sm"} color={fontColor} mt={3} ml={1} mb={-2}>{intl.get("support_unsupport")}</Box>
				{/* <Box>
					<Divider mt={5} mb={3} color={"black"}/>
				</Box> */}
				<Box mt={5}>
					<Box display="flex">
						<InputGroup w={"70%"}>
							<NumberInput 
								w={"70%"}
								borderColor={darkBg}
								borderWidth={0}
								borderLeftRadius={6}
								borderRightRadius={0}
								color={fontColor}
								bg={darkBg}
								defaultValue={fromWei(stakeAmount.current)}
							>
								<NumberInputField onChange={(e) => setStakeAmount(e.target.value)}/> 
							</NumberInput>
							<InputRightAddon
								bg={darkBg}
								color={fontColor}
								borderWidth={0}
								borderLeftRadius={0}
								borderRightRadius={6}
								w={["40%", "25%"]}
								children={STAKING_TOKEN_SYMBOL}
							/>
						</InputGroup>
						<Button w={"30%"} onClick={() => support(1)} bg={pink} color="white">{intl.get("support")}</Button> 
					</Box>
				</Box>
				{!unsupportable ? <></> :
				<Box mt={5}>
					<Box display="flex">
						<InputGroup w={"70%"}>
							<NumberInput
								w={"70%"}
								borderColor={darkBg}
								borderWidth={0}
								borderLeftRadius={6}
								borderRightRadius={0}
								color={fontColor}
								bg={darkBg}
								defaultValue={fromWei(unstakeAmount.current)}
							>
								<NumberInputField onChange={(e) => setUnstakeAmount(e.target.value)}/>
							</NumberInput>
							<InputRightAddon
								bg={darkBg}
								color={fontColor}
								borderWidth={0}
								borderLeftRadius={0}
								borderRightRadius={6}
								w={["40%", "25%"]}
								children={SP_TOKEN_SYMBOL} 
							/>
						</InputGroup>
						<Button w={"30%"} onClick={() => support(0)} bg={'orange'} color={"white"}>{intl.get("unsupport")}</Button>
					</Box>
				</Box>
				}
			</Box>:<></>}
		</>)
	}
	
	const MarketButtons = () => {
		return(
			<Box>
			{status === 5 ? <></> :
			<Box mt={5} borderRadius={6} borderColor={darkBg} borderWidth={1} pt={0} pl={5} pr={5} pb={5}>
			<Box fontSize={"sm"} color={fontColor} mt={3} mb={3} ml={1}>{intl.get("marketplace_operation")}</Box>
			{status === 1 ? 
				<Box>
				<Box display="flex">
					<InputGroup w={"70%"}>
						<NumberInput
							w={"70%"}
							borderColor={darkBg}
							borderWidth={0}
							borderLeftRadius={6}
							borderRightRadius={0}
							color={fontColor}
							bg={darkBg}
							defaultValue={listPrice.current}
						>
							<NumberInputField onChange={(e) => setListPrice(e.target.value)}/> 
						</NumberInput>
						<InputRightAddon
							bg={darkBg}
							color={fontColor}
							borderWidth={0}
							borderLeftRadius={0}
							borderRightRadius={6}
							w={"25%"}
							children={PAYMENT_TOKEN_SYMBOL} 
						/>
					</InputGroup>
					<Button w={"30%"} bg={"orange"} color={"white"} onClick={() => changePrice()}>{intl.get("change_price")}</Button>
				</Box>
				<Box mt={5}>
					<Button w={"30%"} bg={"orange"} color={"white"} onClick={() => unList()}>{intl.get("unlist")}</Button> 
				</Box>
				</Box>	:
				status === 3 ? 
				<Box display="flex">
					<InputGroup w={"70%"}>
						<NumberInput
							w={"70%"}
							borderColor={darkBg}
							borderWidth={0}
							borderLeftRadius={6}
							borderRightRadius={0}
							color={fontColor}
							bg={darkBg}
							defaultValue={listPrice.current}
						>
							<NumberInputField onChange={(e) => setListPrice(e.target.value)}/> 
						</NumberInput>
						<InputRightAddon
							bg={darkBg}
							color={fontColor}
							borderWidth={0}
							borderLeftRadius={0}
							borderRightRadius={6}
							w={"25%"}
							children={PAYMENT_TOKEN_SYMBOL} 
						/>
					</InputGroup>
					<Button w={"30%"} bg={"orange"} color={"white"} onClick={() => list()}>{intl.get("list")}</Button>
				</Box>
				: 
				status === 0 ?
				<Button w={"30%"} bg={pink} color={"white"} onClick={() => buy()}>{intl.get("buy")}</Button> :
				<></>}
			</Box>}
			</Box>
		)
	}

	useEffect(() => {
		// freezing = 
		getBlockTimestamp().then((blockTimestamp) => setUnsupportable(firstSupportTime.add(frozenTime) < blockTimestamp));
	}, [frozenTime, firstSupportTime]);

	useEffect(() => {
			if(nftData.sptBalance !== undefined) {
				getNusicPrice().then((price) => {
					setNusicPrice(price[1]);
					const estimatePrice = nftData.sptBalance.mul(price[1]).div(rate/100);
					setNFTEstimatedPrice(toBigInt(estimatePrice));
				});				
			}
	}, [nftData.sptBalance]);

	const setUnstakeAmount = (value) => {
		// console.log("=>", toWei(value).toString(), unstakeAmount.current.toString());
		value = value === "" ? 0 : value;
		if(toWei(value.toString()).gt(nftData.sptMyBalance)) showError(intl.get("unstake_amount_exceed_balance"));
		unstakeAmount.current = toWei(value.toString());	
	}

	const setStakeAmount = (value) => {
		value = value === "" ? 0 : value;
		if(toWei(value.toString()).gt(stakingTokenBalance)) showError(intl.get("stake_amount_exceed_balance"));
		stakeAmount.current = toWei(value.toString());
	}

	const setListPrice = (value) => listPrice.current = value;

	const showError = (msg) => {
		toast({
			title: intl.get("error"),
			description: msg,
			status: "error",
			duration: 4000,
			isClosable: true
		})
	}

	const showSuccess = (msg) => {
		toast({
			title: intl.get("success"),
			description: msg,
			status: "success",
			duration: 4000,
			isClosable: true
		})
	}

	const changePrice = async () => {
		// console.log("changePrice", listPrice.current)
		if(nftData === undefined || nftData.tokenId === null || nftData.tokenId === undefined) return;

		if(listPrice.current * 1 === 0) {
			showError(intl.get("list_price_zero"));
			return;
		}
		if(nftData.auctionId === null) {
			showError(intl.get("order_id_not_exist"));
			return;
		}
		setHiddenConfirmationProgress(false);
		try {
			setConfirmationProgressData({step: '1/2', value:50, message: intl.get("start")});
			const tx = await marketplaceContract.updatePrice(
				nftData.auctionId, 
				toWei(listPrice.current)
			);
			await tx.wait();
			setConfirmationProgressData({step: '2/2', value: 100, message: intl.get("change_price_done")});
			showSuccess(intl.get("change_price_done"));
			setNftData({
				...nftData,
				startingPrice: listPrice.current,
			})
	
			setTimeout(() => {
				setHiddenConfirmationProgress(true);
			}, 4000);	
		} catch (e) {
			console.error(e.message);
			setHiddenConfirmationProgress(true);
		}
	}

	const unList = async () => {
		if(nftData === undefined || nftData.tokenId === null || nftData.tokenId === undefined) return;

		if(nftData.auctionId === null) {
			showError(intl.get("order_id_not_exist"));
			return;
		}
		setHiddenConfirmationProgress(false);
		try {
			setConfirmationProgressData({step: '1/2', value:50, message: intl.get("start")});
			const tx = await marketplaceContract.cancelOrder(
				nftData.auctionId, 
			);
			await tx.wait();
			setConfirmationProgressData({step: '2/2', value: 100, message: intl.get("cancel_price_done")});
			showSuccess(intl.get("cancel_price_done"));
			setStatus(3);
	
			setTimeout(() => {
				setHiddenConfirmationProgress(true);
			}, 4000);	
		} catch (e) {
			console.error(e.message);
			setHiddenConfirmationProgress(true);
		}
	}

	const list = async () => {
		// console.log("list", listPrice.current)
		if(nftData === undefined || nftData.tokenId === undefined) return;
		if(listPrice.current * 1 === 0) {
			showError(intl.get("list_price_zero"));
			return;
		}
		if(nftData.sptBalance * 1 === 0) {
			showError(intl.get("no_sptoken"));
			return;
		}

		setHiddenConfirmationProgress(false);
		try {
			// Check owner of NFT
			const owner = await nftCoreContract.ownerOf(nftData.tokenId);
			if(owner.toLowerCase() !== currentAccount.toLowerCase()) {
				showError(intl.get("operator_is_not_nft_owner"));
				return;
			}
			// Check allowance of nft tokenId
			setConfirmationProgressData({step: '1/4', value: 10, message: intl.get("start")});
			const approved = await nftCoreContract.getApproved(nftData.tokenId);
			// console.log(approved, MARKETPLACE_ADDRESS);
			if(approved.toLowerCase() !== MARKETPLACE_ADDRESS.toLowerCase()) {
				// approve to operate nft
				setConfirmationProgressData({step: '2/4', value: 20, message: intl.get("approving")});
				const tx = await nftCoreContract.approve(MARKETPLACE_ADDRESS, nftData.tokenId);
				await tx.wait();
			}
			// addOrder
			setConfirmationProgressData({step: '3/4', value: 75, message: intl.get("add_order")});
			const tx = await marketplaceContract.addOrder(
				nftData.tokenId,
				PAYMENT_TOKEN,
				toWei(listPrice.current),
			);
			const res = await tx.wait();
			const orderId = parseInt(res["events"][2]["topics"][1]);

			setConfirmationProgressData({step: '4/4', value: 100, message: intl.get("add_order_done")});
			showSuccess(intl.get("add_order_done"));

			setNftData({
				...nftData,
				auctionId: orderId,
				startingPrice: listPrice.current,
			})
			setStatus(1);

			setTimeout(() => {
				setHiddenConfirmationProgress(true);
			}, 4000);
		} catch (e) {
			console.error(e.message);
			setHiddenConfirmationProgress(true);
		}
	}

	const buy = async () => {
		if(nftData === undefined || nftData.tokenId === undefined) return;
		if(nftData.auctionId === null) {
			showError(intl.get("order_id_not_exist"));
			return;
		}

		if(nftData.sptBalance * 1 === 0) {
			showError(intl.get("no_sptoken"));
			return;
		}

		try {
			setHiddenConfirmationProgress(false);
			// Check balance of payment token
			const payAmount = toWei(nftData.startingPrice);
			setConfirmationProgressData({step: '1/5', value: 10, message: intl.get("checking_payment_token_balance")});
			const balance = await paymentTokenContract.balanceOf(currentAccount);
			// console.log(balance, nftData.startingPrice);
			if(balance.lt(payAmount)) {
				showError(intl.get("payment_token_balance_not_enough"));
				return;
			}
			// Check allowance of payment tokenId
			setConfirmationProgressData({step: '2/5', value: 30, message: intl.get("checking_payment_token_allowance")});
			const allowance = await paymentTokenContract.allowance(currentAccount, MARKETPLACE_ADDRESS);

			if(allowance.lt(payAmount)) {
				// approve to operate payment token
				setConfirmationProgressData({step: '3/5', value: 50, message: intl.get("approving")});
				const tx = await paymentTokenContract.approve(MARKETPLACE_ADDRESS, payAmount);
				await tx.wait();
			}

			// matchOrder
			// Call getAllSupports method
			let addresses = [];
			let amounts = [];
			const ratioOfShare = await allocationDataContract.getAllocationData(0, 1);
			const shareAmount = payAmount.mul(ratioOfShare[0]).div(10000);
			// console.log("shareAmount", payAmount.toString(), ratioOfShare[0].toString(), shareAmount.toString());
			const allSupports = await marketplaceContract.getAllSupports(nftData.auctionId, shareAmount);
			// console.log(allSupports);

			// Order all support and get the top 30 supports
			let supports = [];
			for(let i = 0; i < allSupports[0].length; i++) {
				supports.push({
					address: allSupports[0][i],
					amount: allSupports[1][i],
					to: allSupports[1][i].toString()
				})
			}
			supports.sort((a, b) => {return b.amount.sub(a.amount)});
			// console.log(supports)
			for(let i = 0; i < supports.length; i++) {
				if(i > SHARE_PROFIT_SPT_HOLDERS - 1) break;
				addresses.push(supports[i].address);
				amounts.push(supports[i].amount);
			}

			// Call matchOrder and set 30 supports as params
			setConfirmationProgressData({step: '4/5', value: 75, message: intl.get("match_order")});
			// console.log('Supporters addresses', addresses);

			// Just upload support addresses, the amount will be get in contract to avoid the buyer cheat the supporters and amount
			const tx = await marketplaceContract.matchOrder2(
				nftData.auctionId,
				payAmount,
				addresses,
			);
			await tx.wait();
			setConfirmationProgressData({step: '5/5', value: 100, message: intl.get("match_order_done")});
			showSuccess(intl.get("match_order_done"));
			setStatus(3);

			setTimeout(() => {
				setHiddenConfirmationProgress(true);
			}, 4000);
		} catch (err) {
			console.log(err.message);
			showError(intl.get("contract_error"));
			setHiddenConfirmationProgress(true);
		}
	}

	const support = async(type) => {
		if(type === 1) {
			// support
			try {
				if(stakeAmount.current * 1 === 0) {
					showError(intl.get("amount_not_zero"));
					return;
				}
				if(stakeAmount.current.gt(stakingTokenBalance)) {
					showError(intl.get("stake_amount_exceed_balance"));
					return;
				}

				// Check allowance of staking token
				// const amount = stakeAmount.current.toString();
				setHiddenConfirmationProgress(false);
				setConfirmationProgressData({step: '1/4', value: 10, message: intl.get("checking_allowance")});
				const allowance = await stakingTokenContract.allowance(currentAccount, SP_TOKEN_FACTORY);
				if(stakeAmount.current * 1 > allowance) {
					// Approve staking token
					setConfirmationProgressData({step: '2/4', value: 30, message: intl.get("approving") + intl.get("amount") + format(fromWei(stakeAmount.current), 2) + STAKING_TOKEN_SYMBOL});
					const tx = await stakingTokenContract.approve(SP_TOKEN_FACTORY, stakeAmount.current);
					await tx.wait();
				}
				// Call support method
				setConfirmationProgressData({step: '3/4', value: 50, message: intl.get('supporting')});
				const tx = await sptokenFactoryContract.support(stakeAmount.current, nftData.tokenId);
				await tx.wait();
				setConfirmationProgressData({step: '4/4', value: 100, message: intl.get("supporting_done")});
				showSuccess(intl.get("support_success"));

				setNftData({
					...nftData,
					sptMyBalance: nftData.sptMyBalance === undefined ? stakeAmount.current.mul(rate/100) : nftData.sptMyBalance.add(stakeAmount.current.mul(rate/100)),
					balance: nftData.sptBalance === undefined ? stakeAmount.current.mul(rate/100) : nftData.sptBalance.add(stakeAmount.current.mul(rate/100)),
				})

				setStakingTokenBalance(stakingTokenBalance.sub(stakeAmount.current));

				setTimeout(() => {
					setHiddenConfirmationProgress(true);
				}, 4000);
			} catch (err) {
				showError(err.message);
				setHiddenConfirmationProgress(true);
			}
		} else if(type === 0) {
			// unsupport
			try {
				if(unstakeAmount.current.gt(nftData.sptMyBalance)) {
					showError(intl.get('unstake_amount_exceed_balance'));
					return;
				}
				if(unstakeAmount.current * 1 === 0) {
					showError(intl.get("amount_not_zero"));
					return;
				}

				// Check allowance of sptoken	
				// const amount = unstakeAmount.current.toString();
				setHiddenConfirmationProgress(false);
				const spTokenContract = SPTokenContract(nftData.sptAddress);
				setConfirmationProgressData({step: '1/4', value: 10, message: intl.get("checking_allowance")});
				const allowance = await spTokenContract.allowance(currentAccount, SP_TOKEN_FACTORY);
				// console.log('allowance', allowance);
				if(unstakeAmount.current * 1 > allowance) {
					// Approve sptoken
					setConfirmationProgressData({step: '2/4', value: 30, message: intl.get("approving") + intl.get("amount") + format(fromWei(unstakeAmount.current), 2) + SP_TOKEN_SYMBOL});
					const tx = await spTokenContract.approve(SP_TOKEN_FACTORY, unstakeAmount.current);
					await tx.wait();
				}
	
				// Call unsupport method
				setConfirmationProgressData({step: '3/4', value: 50, message: intl.get("unsupporting")});
				const tx = await sptokenFactoryContract.unsupport(unstakeAmount.current, nftData.tokenId);
				await tx.wait();
				setConfirmationProgressData({step: '4/4', value: 100, message: intl.get("unsupporting_done")});
				showSuccess(intl.get("unsupport_success"));

				setNftData({
					...nftData,
					sptMyBalance: nftData.sptMyBalance.sub(unstakeAmount.current),
					balance: nftData.sptBalance.sub(unstakeAmount.current),
				})

				setStakingTokenBalance(stakingTokenBalance.add(unstakeAmount.current.div(rate/100)));

				setTimeout(() => {
					setHiddenConfirmationProgress(true);
				}, 4000);
			} catch (err) {
				showError(err.message);
				setHiddenConfirmationProgress(true);
			}
		}
	}

	const LeftInfoLine = (props) => {
		return(
		<Box fontSize={14} mb={3} color={fontColor} w={"100%"}>
			<Box ml={1}>{props.title}</Box>
			<Box bg={darkBg} p={2.5} mt={1} borderRadius={6}><a href={`${ETHER_SCAN_URL}address/${props.address}`} target="_blank" rel="noreferrer">{shortAddress(props.address, 12)}</a></Box>
		</Box>)
	}

	return(
		<Box>
			{nftData.tokenId === undefined ? 
			<Box
				mt={10}
				w={["90%", "60%"]}
				ml={["5%", "20%"]}
				p={5}
				color={"white"}
				bg={darkBg}
				borderRadius={10}
				textAlign={"center"}
			>
				Loading data! If long time not loaded, please check your id, maybe it is not available.
			</Box> :
			<Box
				mt={10}
				w={["90%", "60%"]}
				ml={["5%", "20%"]}
				bg={bg}
				p={5}
				borderRadius={10}
			>
				<SimpleGrid columns={[1, null,  5]} gap={6}>
					<GridItem colSpan={[1, null, 2]}>
						<Box>
							{/* <Box color={darkBg}>{'Status: ' + status}</Box> */}
							{/* <Box>{'Frozentime: ' + frozenTime}</Box> */}
							<Image 
								src={nftData.imageBase64 === null ? loadingImage : nftData.imageBase64} 
							/>
							<Box py={5} align="center">
							<audio src={nftData.audio === undefined ? '' : ipfsToHttp(nftData.audio)} controls controlsList="nodownload"/>
							</Box>
						</Box>
						{/* <Box
							mb={5}
							color={"white"}
							textAlign="center"
						>
							<ShareBar url={BASE_WEB_URL + 'id/' + nftData.tokenId} onDone={()=>{}}/>
						</Box> */}
						<Box>
							<LeftInfoLine title={intl.get("nft_address")} address={NFT_ADDRESS}/>
							{nftData.sptAddress === undefined ? <></> : <LeftInfoLine title={intl.get("spt_address")} address={nftData.sptAddress}/>}
							<LeftInfoLine title={intl.get("staking_token_address")} address={STAKING_TOKEN}/>
							<LeftInfoLine title={intl.get("sptoken_factory_address")} address={SP_TOKEN_FACTORY}/>
							<LeftInfoLine title={intl.get("marketplace_address")} address={MARKETPLACE_ADDRESS}/>
							<LeftInfoLine title={intl.get("allocation_address")} address={ALLOCATION_ADDRESS}/>
							<LeftInfoLine title={intl.get("vault_address")} address={NUSIC_VAULT}/>
							{IPAccounts[0] === undefined ? <></> :
							<Box>
								<LeftInfoLine title={intl.get("ip_owner")} address={IPAccounts[0]}/>
								<LeftInfoLine title={intl.get("ip_incentive")} address={IPAccounts[2]}/>
							</Box>}
						</Box>
					</GridItem>
					<GridItem colSpan={[1, null, 3]}>
						{nftData === undefined ? <></> :
						<Box mb={3}>
						<InfoLine title={intl.get("nft_token_id")} content={nftData.tokenId === undefined ? '' : nftData.tokenId}/>
						<InfoLine title={intl.get("music_name")} content={nftData.name === undefined ? '' : nftData.name}/>
						<InfoLine title={intl.get("artist_name")} content={nftData.attributes === undefined ? '' : nftData.attributes.artist}/>
						<InfoBlock height={"100px"} title={intl.get("description")} content={nftData.description === undefined ? '' : nftData.description}/>
						<InfoLine title={intl.get("owner")} content={status === 3 ? intl.get('you') : status === 0 || status === 1 ? intl.get('onsale') : shortAddress(nftData.nftOwner, 12)}/>
						<InfoLine title={intl.get("trade_times")} content={tradeTimes === undefined ? "0" : tradeTimes.toString()}/>
						<InfoLine title={intl.get("total_spt")} content={nftData.sptBalance === undefined ? '0' : format(fromWei(nftData.sptBalance), 0)}/>
						<InfoLine title={intl.get("my_spt_amount")} content={nftData.sptMyBalance === undefined ? '0' : format(fromWei(nftData.sptMyBalance), 0)}/>
						<InfoLine 
							title={intl.get("spt_releasable")}
							content={format(fromWei(allReleasable), 4) + " " + SP_TOKEN_SYMBOL}
							url={BASE_WEB_URL + 'claimsptoken/' + nftData.tokenId}
							linkText={intl.get("spt_release_button")}
						/>
						<InfoLine title={intl.get("first_support_time")} content={firstSupportTime.toString() === MAX_TIMESTAMP ? 'No support staking' : date.format(new Date(firstSupportTime.mul(1000).toNumber()), "YYYY-MM-DD HH:mm:ss")}/>
						<InfoLine title={intl.get("frozen_time")} content={unsupportable ? frozenTime.div(3600*24).toString()+" Days" : frozenTime.div(3600*24).toString() + " Days " + intl.get("can_not_unsupport")}/>
						<InfoLine title={intl.get("exchange_rate")} content={rate === undefined ? '0' : (rate/100).toString() + " " + SP_TOKEN_SYMBOL + "/" + STAKING_TOKEN_SYMBOL}/>
						<InfoLine title={intl.get("staking_token_balance")} content={stakingTokenBalance === undefined ? '0' : format(fromWei(stakingTokenBalance), 2) + " " + STAKING_TOKEN_SYMBOL}/>
						<InfoLine title={intl.get("nusic_price")} content={nusicPrice === undefined ? '0' : format(fromWei(nusicPrice), 5) + " " + PAYMENT_TOKEN_SYMBOL}/>
						<InfoLine title={intl.get("estimated_price")} content={NFTEstimatedPrice === undefined ? '0' : format(fromWei(NFTEstimatedPrice), 2) + " " + PAYMENT_TOKEN_SYMBOL}/>
						{nftData.sptBalance === undefined ? 
						// Never has been staked by anyone
						<StakeButtons/>
						: 
						// Staked already, has SPToken
						getScore(nftData.sptBalance, favours) < NFT_ONSALE_MIN_SCORE ? 
						// Not for sale cause the score is not enough
						<Box>
							{/* alert that the score is not enough for sale */}
							<Box color="red" fontSize={12}>
								{`${intl.get("score_not_enough")}${format(NFT_ONSALE_MIN_SCORE, 0)}${intl.get("score")}`}
							</Box>

							{/* Show stake/unstake buttons */}
							<StakeButtons/>
						</Box>
							: 
							// For sale
						<Box>
							{/* nft has been listed, show the price */}
							{status === 0 || status === 1 ?
							<InfoLine title={intl.get("price")} content={nftData.startingPrice === undefined ? '0' : nftData.startingPrice + ' ' + PAYMENT_TOKEN_SYMBOL}/>
							: <></>}
							{/* Show stake/unstake buttons */}
							<StakeButtons/>
						</Box>
						}
						<MarketButtons/>
						</Box>
					}

					{hiddenConfirmationProgress ? <></> :
					<Box color={fontColor} w={"90%"} ml={"5%"}>
					<ConfirmationProgress 
						step={confirmationProgressData.step}
						value={confirmationProgressData.value}
						message={confirmationProgressData.message}
					/></Box>}

					</GridItem>
				</SimpleGrid>
			</Box>
			}
		</Box>
	)
}

export default ItemDetailBody;